import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class CountThirdDocsPendingCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }
  run(third_id, third_kind): Promise<any> { 
    let args = {third_id: third_id, third_kind: third_kind};
    try {
      return this.dispatcher.dispatch('count.third.docs.pending', args);
    } catch(error) {
      console.error('Error al consultar los documentos no contabilizados del tercero', error);
    }
  }
}